import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecipe, RecipeData } from '../../context/RecipeContext';
import { useAuth } from '../../context/AuthContext';
import RecipeForm from '../../components/RecipeForm/Recipe';
import Header from '../../components/Header';
import styles from './RecipeFormScreen.module.css';
import { usePageSEO } from '../../hooks/usePageSEO';

const RecipeFormScreen: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const { getRecipeById } = useRecipe();
  const { user, logout } = useAuth();
  const [initialRecipe, setInitialRecipe] = useState<RecipeData | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      setLoading(true);
      getRecipeById(id).then(recipe => {
        setInitialRecipe(recipe || undefined);
        setLoading(false);
      });
    }
  }, [id, getRecipeById]);

  // SEO hook for the recipe form page - must be called before any conditional returns
  usePageSEO({
    title: `${id ? 'Edit Recipe' : 'Create New Recipe'} | PlatefullAI - Build Your Dietary Recipe Collection`,
    description: id ? 'Edit your recipe and customize ingredients, instructions, and dietary attributes to match your digital diet identity.' : 'Create recipes that align with your dietary preferences and restrictions. Build a personalized recipe collection that respects your digital diet identity.',
    keywords: id ? 'edit recipe, modify recipe, dietary recipe, recipe editor, dietary preferences' : 'create recipe, dietary recipe, recipe builder, dietary restrictions, food allergies, personalized nutrition, digital diet identity',
    canonicalUrl: `https://platefullai.com/recipes/${id ? id + '/edit' : 'new'}`
  });

  if (id && loading) return <div className={styles.loading}>Loading...</div>;

  const handleLogin = () => {
    // TODO: Navigate to login page or show login modal
    console.log('Login clicked');
  };

  return (
    <div className={styles.pageWrapper}>
      <Header user={user} onLogin={handleLogin} onLogout={logout} />
      <RecipeForm
        mode={id ? 'edit' : 'create'}
        initialRecipe={initialRecipe}
        onClose={() => navigate('/')}
      />
    </div>
  );
};

export default RecipeFormScreen; 